import { create } from "zustand";
import type { EditorView } from "@codemirror/view";
import type { Editor } from "@tiptap/react";

interface SelectionRange {
  from: number;
  to: number;
  text: string;
}

interface EditorState {
  editorView: EditorView | null;
  docxEditor: Editor | null;
  selection: SelectionRange | null;
  cursorLine: number;
  showSelectionToolbar: boolean;
  selectionToolbarPosition: { x: number; y: number } | null;

  setEditorView: (view: EditorView | null) => void;
  setDocxEditor: (editor: Editor | null) => void;
  setSelection: (selection: SelectionRange | null) => void;
  setCursorLine: (line: number) => void;
  setShowSelectionToolbar: (show: boolean) => void;
  setSelectionToolbarPosition: (position: { x: number; y: number } | null) => void;
}

export const useEditorStore = create<EditorState>()((set) => ({
  editorView: null,
  docxEditor: null,
  selection: null,
  cursorLine: 1,
  showSelectionToolbar: false,
  selectionToolbarPosition: null,

  setEditorView: (view) => set({ editorView: view }),
  setDocxEditor: (editor) => set({ docxEditor: editor }),
  setSelection: (selection) => set({ selection }),
  setCursorLine: (line) => set({ cursorLine: line }),
  setShowSelectionToolbar: (show) => set({ showSelectionToolbar: show }),
  setSelectionToolbarPosition: (position) => set({ selectionToolbarPosition: position }),
}));
